// extracted by mini-css-extract-plugin
export var infoItem = "_qm-2";
export var title = "_qm-0";
export var value = "_qm-1";